import styled from "styled-components";
import {ReactComponent as Logo} from '../../assets/images/logo-ssio.svg';

export const SSIOLogo = styled(Logo)`
  &&& {
    height: 32px;
    margin: 8px 16px 16px 0;
  }
`;